<script>
export default {
  props: {
    selected: {type: Array},
    selectedDocument: {type: Object},
  },
}

</script>
<template>
  <v-card class="fill-height" style="overflow-y: auto;max-height:83vh;">
    <v-card-title>{{$t('component.documentValidation.coverSheet.documentsListSidebar.header')}}</v-card-title>
    <v-divider></v-divider>
    <v-list v-for="(item,index) in selected" :key="index" dense style="padding:0;">
      <v-list-item
        :class="[selectedDocument === item ? 'isActive' : '']"
        @click="$emit('select-document', item)">
        <v-row>
          <v-col cols="8">
            <span style="font-size: 13px;">{{ item.uploadFileName }}</span>
          </v-col>
          <v-col cols="4" class="text-right">
            <!-- Success -->
            <v-icon v-if="item.coverSheetStatus === 200 || item.coverSheetId !== null" class="ml-2" color="success">
              mdi-check
            </v-icon>
            <!-- Errors -->
            <v-tooltip v-if="item.hasOwnProperty('errors') && item.errors.length > 0">
              <template #activator="{props}">
                <v-icon class="ml-2" color="warning" v-bind="props">mdi-alert</v-icon>
              </template>
              <span>{{ item.coverSheetStatus === 200 ? $t('component.documentValidation.coverSheet.documentsListSidebar.success') : '' }}</span>
            </v-tooltip>
            <!-- Pristine -->
            <!--            <v-icon-->
            <!--                v-if="item.coverSheetStatus === undefined && !item.errors && item.coverSheetId === null"-->
            <!--                class="ml-2"-->
            <!--                color="warning">-->
            <!--              mdi-minus-->
            <!--            </v-icon>-->
            <v-icon class="ml-2" color="error" @click="$emit('delete-document')">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<style scoped>
.isActive {
  background-color: var(--v-primary);
  color: white !important;
}
</style>
